export var baseURL = process.env.FINECT_BASEURL || 'www.finect.com';